'use client';

import type { DepositErrorCode } from '@/modals/modules/balances/+DepositResultModal/components/consts/paytechToDepositErrorCode';
import { useEffect } from 'react';
import { resolveDepositErrorModal } from '@/modals/modules/balances/+DepositResultModal/components/consts/paytechToDepositErrorCode';
import openModal from '@/modals/utils/openModal';
import { useAppSelector } from '@/redux/hooks';
import { ordersApi } from './orders.api';

export const PENDING_DEPOSIT_ORDER_STORAGE_KEY = 'pendingDepositOrderId';

export function useDepositOrderTracking() {
  const userSession = useAppSelector(state => state.user.userSession);

  useEffect(() => {
    if (!userSession) {
      return;
    }

    const orderId = localStorage.getItem(PENDING_DEPOSIT_ORDER_STORAGE_KEY);
    if (!orderId) {
      return;
    }

    localStorage.removeItem(PENDING_DEPOSIT_ORDER_STORAGE_KEY);

    ordersApi.getById(orderId).then((order) => {
      const resultCode = resolveDepositErrorModal(order.transaction.error?.internalCode);

      if (resultCode) {
        const listCodesToNotSetOrder: DepositErrorCode[] = ['LIMIT_REACHED', 'LIMIT_EXCEEDED', 'SECURITY_CHECK_REQUIRED'];
        const activeOrderId = !listCodesToNotSetOrder.includes(resultCode) ? order.id : undefined;

        openModal('deposit-result', { resultCode, activeOrderId });
      } else if (order.state === 'success') {
        openModal('deposit-result', { resultCode: 'DEPOSIT_SUCCESS' });
      }
    }).catch(() => {});
  }, [userSession]);
}
